import { http, providerApi } from '@/core/api/';
import codeDocumentTypes from '@/utils/constants/documentTypes';
import fileInputStatus from '../../utils/constants/fileInputStatus';

const apiUrl = 'api/pei';
const apiService = Object.freeze({
  generalPeiAtInformation(peiId) {
    return http.get(`api/atservice/getpeiatservice?peiId=${peiId}`);
  },

  generalPeiCodeAt() {
    return http.get(`api/atservice/getpeiatcode`);
  },
  getAnalysisService(analysisServiceId) {
    return http.get(
      `api/pei/getpeianalysisservice?analysisServiceId=${analysisServiceId}`
    );
  },
  getAnalysisServiceByPeiAndDisciplineType(peiId, studentServiceId) {
    return http.get(
      `api/pei/getpeianalysisservicebypeianddisciplinetypeid/${peiId}/${studentServiceId}`
    );
  },
  documentsUploadFiles(files) {
    return http.post(`api/atservice/uploadatdocument`, files, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  downloadDocument(documentFile) {
    const byteChars = atob(documentFile.content);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    let blob = new Blob([byteArray], {
      type: documentFile.contentType,
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  documentsDownloadFiles(peiAtServiceId, codeDocumentType) {
    http
      .get(
        `api/atservice/downloadatdocument?peiAtServiceId=${peiAtServiceId}&codeDocumentType=${codeDocumentType}`
      )
      .then((response) => {
        apiService.downloadDocument(response.data);
      });
  },
  downloadStudentDocument(evaluationId, documentId) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `api/studentevaluation/${evaluationId}/downloadDocuments/${documentId}`
        )
        .then((response) => {
          if (response && response.data) {
            apiService.downloadDocument(response.data);
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  documentsPeiDownloadFiles(id) {
    http.get(`api/pei/downloaddocument?id=${id}`).then((response) => {
      apiService.downloadDocument(response.data);
    });
  },
  documentDownloadLocalFile(file) {
    let fr = new FileReader();
    fr.readAsDataURL(file);
    let blob = new Blob([file], { type: 'application/pdf' });

    let objectURL = window.URL.createObjectURL(blob);

    let link = document.createElement('a');
    link.href = objectURL;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
  documentDownloadReport(content, filename, contentType) {
    let binaryString = window.atob(content);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }

    let blob = new Blob([bytes], { type: contentType || 'application/pdf' });

    let objectURL = window.URL.createObjectURL(blob);

    let link = document.createElement('a');
    link.href = objectURL;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
  documentsDeleteFiles(peiAtServiceId) {
    return http.get(
      `api/atservice/deleteatdocument?peiAtServiceId=${peiAtServiceId}`
    );
  },
  documentsLoadFiles(peiAtServiceId) {
    return http.get(
      `api/atservice/loadatdocument?peiAtServiceId=${peiAtServiceId}`
    );
  },
  convertToBlob(documentFile) {
    const blob = apiService.getBlobConversion(documentFile);
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.fileName;
    link.click();
  },
  getBlobConversion(documentFile) {
    const byteArray = apiService.convertToByteArray(documentFile.content);
    return new Blob([byteArray], {
      type: documentFile.contentType,
    });
  },
  convertToByteArray(documentContent) {
    const byteChars = atob(documentContent);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    return new Uint8Array(byteNumbers);
  },
  async evaluationDownloadFiles(
    studentEvaluationId,
    studentEvaluationsDocumentIds
  ) {
    return http
      .get(
        `/api/studentevaluation/${studentEvaluationId}/documents/${studentEvaluationsDocumentIds}`,
        { responseType: 'blob' }
      )
      .then((response) => {
        let blob = new Blob([response.data], { type: 'application/pdf' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Documento Adjunto.pdf';
        link.click();
      })
      .catch((e) => {
        return e;
      });
  },
  async downloadDocumentByAttachmentId(
    studentEvaluationsDocumentIds,
    studentEvaluationsAttachmentIds
  ) {
    let documentId = null;
    if (studentEvaluationsDocumentIds != '') {
      documentId = studentEvaluationsDocumentIds;
    }
    let attachmentId = null;
    if (studentEvaluationsAttachmentIds != '') {
      attachmentId = studentEvaluationsAttachmentIds;
    }
    return http
      .get(`/api/documents/getdocument/${documentId}/${attachmentId}/2`)
      .then((response) => {
        apiService.downloadDocument(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  // Download document according to attachment id and category.
  async downloadDocumentByAttachmentIdByDocumentCategory(
    attachmentId,
    documentCategory
  ) {
    return http
      .get(
        `/api/documents/documentbycategory/${attachmentId}/${documentCategory}`
      )
      .then((response) => {
        apiService.downloadDocument(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  async downloadDocumentForThrerapyReferral(attachmentId) {
    return http
      .get(`/api/documents/downloadtherapyreferral/${attachmentId}`)
      .then((response) => {
        apiService.downloadDocument(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  async getDocument(id) {
    return http
      .get(`/api/documents/${id}`)
      .then((response) => {
        apiService.downloadDocument(response.data);
      })
      .catch((e) => {
        throw e;
      });
  },
  async downloadDocumentForRP(attachmentId) {
    return http
      .get(`/api/documents/downloadrp/${attachmentId}`, {
        responseType: 'blob',
      })
      .then((response) => {
        let blob = new Blob([response.data], { type: 'application/pdf' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Documento Adjunto.pdf';
        link.click();
      })
      .catch((e) => {
        return e;
      });
  },
  deleteDocumentByAttachmentId(attachmentId) {
    return http.delete(`/api/pei/deletedocument?id=${attachmentId}`);
  },
  async uploadRejectedLocationDocument(document) {
    let hasDocumentToUpload =
      document.status == fileInputStatus.Loaded &&
      document.file != null &&
      document.date != null;
    if (document.status == fileInputStatus.Deleted) {
      await http.delete(`/api/pei/deletedocument?id=${document.attachmentId}`);
    } else if (hasDocumentToUpload) {
      let formData = new FormData();

      formData.append('date', document.date);
      formData.append('file', document.file);
      formData.append(
        'documentTypeId',
        codeDocumentTypes.LocationRejectedDocument
      );
      formData.append('id', document.id);
      if (document.attachmentId)
        formData.append('itemAttachmentId', document.attachmentId);

      await http.post('/api/pei/uploaddocument', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
  },
  async uploadDocument(document) {
    let hasDocumentToUpload =
      document.status == fileInputStatus.Loaded &&
      document.file != null &&
      document.date != null;

    if (document.status == fileInputStatus.Deleted) {
      await http.delete(`/api/pei/deletedocument?id=${document.attachmentId}`);
    } else if (hasDocumentToUpload) {
      let formData = new FormData();

      formData.append('date', document.date);
      formData.append('file', document.file);
      formData.append('documentTypeId', document.documentType);
      formData.append('id', document.id);

      if (document.attachmentId)
        formData.append('itemAttachmentId', document.attachmentId);

      await http.post('/api/pei/uploaddocument', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
  },
  async getAmendmentSections(peiId) {
    const response = await http.get(
      `/api/pei/getsectionsamendment?peiId=${peiId}`
    );
    return response.data;
  },
  async getallanalysisservice(peiId) {
    const response = await http.get(`/api/pei/getallanalysisservice/${peiId}`);
    return response.data;
  },
  async saveAdmendmentSections(admenment) {
    return await http.post('/api/pei/addpeievaluationamendment', admenment, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  async changeStatus(peiId, statusId) {
    await http.post('/api/pei/changeStatus', {
      peiid: peiId,
      statusId: parseInt(statusId),
    });
  },
  async disableReferralWithServicesRemovedInCurrentPei(model) {
    await http.post('/api/pei/disableReferralWithServicesRemovedInCurrentPei', {
      peiId: model.peiId,
      studentSieId: model.studentSieId,
      configAcademicYearId: model.configAcademicYearId,
      generalRevisionNo: model.generalRevisionNo,
    });
  },
  async signPei(peiSign) {
    return await http.post('/api/pei/signpei', {
      peiId: peiSign.peiId,
      signedDate: peiSign.signedDate,
      studentTardinessLog: peiSign.studentTardinessLog,
      hasRequiredFuturePeiCopy: peiSign.hasRequiredFuturePeiCopy,
    });
  },
  async getPeiSignDetail(peiId) {
    return await http.get(`/api/pei/${peiId}/signdetail`);
  },
  async getServiceModalityTypes(peiId, isTherapy, isTypeOther) {
    isTherapy = isTherapy === true;
    isTypeOther = isTypeOther === true;

    return await http.get(
      `${apiUrl}/modalitytypes?peiId=${peiId}&isTherapy=${isTherapy}&isTypeOther=${isTypeOther}`
    );
  },
  async getDurations(peiId, modalityId, isTherapy) {
    isTherapy = isTherapy === true;
    modalityId = modalityId > 0 ? modalityId : 0;

    return await http.get(
      `${apiUrl}/durations?peiId=${peiId}&modalityId=${modalityId}&isTherapy=${isTherapy}`
    );
  },
  async getReferralDocuments(analysisServiceId) {
    return await http.get(`${apiUrl}/referraldocuments/${analysisServiceId}`);
  },
  async getReferralDocumentsByStudentServiceId(studentServiceId, peiId) {
    return await http.get(
      `${apiUrl}/getallreferralitemattachment/${studentServiceId}/${peiId}`
    );
  },
  async getAllPeiServiceNeed(peiId) {
    return await http.get(`${apiUrl}/AllPeiServiceNeed?peiId=${peiId}`);
  },
  async getPeiServiceNeedInterpreterLevel() {
    return await http.get(`${apiUrl}/peiserviceneedtypeinterpreterlevel`);
  },
  async getStudentEvaluationServices(
    studentSieId,
    therapyDisciplineTypeId,
    studentServiceId,
    peiId
  ) {
    peiId = peiId || '';
    return await http.get(
      `api/studentEvaluation/studentevaluationsbytherapy?studentSieId=${studentSieId}&studentServiceId=${studentServiceId}&therapyDisciplineTypeId=${therapyDisciplineTypeId}&peiId=${peiId}`
    );
  },

  async LastPeiAdditionalQuestions(ExitId) {
    return await http.get(`api/student/LastPeiAdditionalQuestions/${ExitId}`);
  },
  async downloadReport(name) {
    return apiService
      .getReport(name)
      .then((response) => {
        apiService.ConvertToBlob(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  getReport(name) {
    return providerApi.get(`/api/report/${name}`);
  },
  async downloadMipeReport(name) {
    return apiService
      .getMipeReport(name)
      .then((response) => {
        apiService.ConvertToBlob(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  getMipeReport(name) {
    return http.get(`/api/report/${name}`);
  },
  ConvertToByteArray(documentContent) {
    const byteChars = atob(documentContent);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    return byteArray;
  },
  getBlobConvertion(documentFile) {
    const byteArray = apiService.ConvertToByteArray(documentFile.content);
    return new Blob([byteArray], {
      type: documentFile.contentType,
    });
  },
  async ConvertToBlob(documentFile) {
    const blob = apiService.getBlobConvertion(documentFile);

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  async checkIfAnyDocumentIsRelatedToPei(peiId) {
    return await http.get(`/api/pei/documents/${peiId}/any`);
  },
  async cancelDigitalSignature(peiId, reason, isRenderedIneffective = false) {
    return await http.post(
      `/api/pei/canceldigitalsignature/${peiId}?isRenderedIneffective=${isRenderedIneffective}`,
      reason
    );
  },
  async getTypeIdOfSignatures(peiId) {
    return await http.get(`/api/pei/${peiId}/signature/typeids`);
  },
  async getStudentFunction(peiId) {
    return await http.get(`/api/pei/${peiId}/getstudentfunction`);
  },
  async uploadSignDocuments(peiId, formData) {
    return await http.put(`/api/pei/${peiId}/uploadsignDocuments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  async validateStatusCheckList(peiId) {
    return await http.get(`/api/pei/validatestatuschecklist/${peiId}`);
  },
  async getSignatureDocument(documentId, withCertificate) {
    const doc = await http.get(
      `${apiUrl}/digitalsignature/document/${documentId}/${withCertificate}`
    );
    apiService.convertToBlob(doc.data);
  },
  async getSelectedPeiServiceNeed(peiId) {
    return await http.get(`${apiUrl}/GetSelectedPeiServiceNeed/`, {
      params: { peiId },
    });
  },
  async getAtLastSignedPeiDocument(atServiceId) {
    return await http.get(`${apiUrl}/atlassignedpeidocument/${atServiceId}`);
  },
  async getSAmendmentByPeiId(peiId) {
    return await http.get(`${apiUrl}/getamendmentbypei/${peiId}`);
  },
  async getPartEvaluationAmendmentServiceById(peiId) {
    return await http.get(`${apiUrl}/getevaluationamendmentservice/${peiId}`);
  },
  async deleteCompuMinuteDocument(peiId) {
    return await http.delete(`${apiUrl}/${peiId}/signpeidocument/compuminute`);
  },
  async deletePeiSignatureDocument(peiId, documentId) {
    return await http.delete(
      `${apiUrl}/signpeidocument/${peiId}/${documentId}`
    );
  },
  async getListUsertoSign(param) {
    return await http.get(`${apiUrl}/getusertosign`, {
      params: param,
    });
  },
  async getPei(peiId) {
    return await http.get(`${apiUrl}/getpei?peiId=${peiId}`);
  },
  async getPeiCodeTypes(code) {
    return await http.get(`${apiUrl}/peicodetypes`, {
      params: { code },
    });
  },
  async getEducationalCompensatoryOptions(academicYearId) {
    return await http.get(
      `${apiUrl}/educationalcompensatoryoptions/${academicYearId}`
    );
  },
  async hasAnyEducativeServiceInAee(peiId) {
    return await http.get(`${apiUrl}/hasanyeducativeserviceinaee/${peiId}`);
  },
  async getLastPeiEducationalService(studentSieId, academicYearId) {
    return await http.get(
      `${apiUrl}/lastpeieducationalservice/${studentSieId}/${academicYearId}`
    );
  },
  async getEducationalCompensatoryServiceBalance(
    studentSieId,
    excludeRejectedAndIncomplete = false
  ) {
    return await http.get(
      `${apiUrl}/educationalcompensatoryservicebalance/${studentSieId}?excludeRejectedAndIncomplete=${excludeRejectedAndIncomplete}`
    );
  },
  async saveEducationalCompensatoryServices(payload) {
    return await http.post(
      `${apiUrl}/educationalcompensatoryservice/save`,
      payload
    );
  },
  async getEducationalCompensatoryServices(peiId, params = {}) {
    return await http.get(`${apiUrl}/educationalcompensatoryservice/${peiId}`, {
      params,
    });
  },
  async updateEducationalService(payload) {
    return await http.patch(`${apiUrl}/update/educationalrequest`, payload);
  },
  async removeEducationalService(requestId) {
    return await http.patch(`${apiUrl}/remove/educationalrequest/${requestId}`);
  },
  async rejectEducationalService(params) {
    return http.put(`${apiUrl}/rejecteducationalservice`, params);
  },
  async getPeiQuantity(sie, params = {}) {
    return await http.get(`${apiUrl}/student/${sie}/quantity`, { params });
  },
  async getRecommendedLocation(peiId) {
    return await http.get(`${apiUrl}/getrecommendedlocation?peiId=${peiId}`);
  },
  async replaceLocationRejectedDocument(peiId, file) {
    return await http.put(
      `${apiUrl}/${peiId}/replacelocationrejecteddocument`,
      file
    );
  },
});
export default apiService;
